import type { SVGProps } from 'react';
import { AnimalFace } from './AnimalFace';

export function AnimalGiraffe(props: SVGProps<SVGSVGElement>) {
  return (
    <AnimalFace size={150} {...props}>

  <>
    <path
      d="M41.117 93.918c3.525 3.017 1.417 4.434 7.06 3.65 6.62-.918 8.526-2.31 18.952-3.016 21.487-1.457 32.123 1.762 35.708 1.633 4.318-.155 2.776-2.314 6.943-5.71 2.835-2.31 5.589-2.806 7.998-1.96-1.116-5.086-2.439-10.025-3.684-14.416-4.413-15.596-11.196-32.575-29.154-36.027-16.56-3.18-30.87-.056-38.785 11.274-7.561 10.83-11.033 25.417-12.8 41.47 2.729.077 6.08 1.663 7.762 3.102"
      fill="#FBC732"
    />
    <path
      d="M68.814 39.47c-2.724 1.393-2.913 7.055-.647 8.417 2.267 1.358 10.95 1.254 10.265-5.65-.336-3.357-6.89-4.158-9.618-2.766M79.782 52.73c1.974 4.008 11.075 3.542 11.648-3.568.457-5.594-3.05-8.197-6.774-7.714-3.728.487-6.352 8.282-4.874 11.282M79.277 57.417c-2.314 1.336-.741 5.555 1.801 5.965 2.539.409 3.547-2.15 3.56-2.694.043-2.542-4.15-3.969-5.361-3.27zM64.586 52.114c-1.142 1.74-1.167 4.137 1.483 5.24 2.65 1.103 6.977 1.508 7.955-1.677.974-3.18-6.227-8.455-9.438-3.563zM59.773 41.713c-2.887 1.155-3.052 9.817 1.784 8.576 4.835-1.246 1.103-9.735-1.784-8.576zM75.395 69.081c3.357-.65 2.125-10.222-3-8.869-6.028 1.59-2.322 9.89 3 8.87z"
      fill="#E79335"
    />
    <path
      d="M101.583 47.64c8.218-2.102 22.572-7.14 19.707-18.41-1.496-5.873-9.059-3.231-13.476-1.417-5.921 2.426-10.442 8.046-13.527 13.751 2.788 1.642 5.197 3.706 7.296 6.077"
      fill="#FBC732"
    />
    <path
      d="M99.958 45.922c3.168-1.513 9.981-4.633 12.67-6.486 4.387-3.025 6.985-6.533 6.292-7.955-.694-1.422-13.571 3.189-17.971 8.537-1.09 1.327-2.335 2.474-3.361 3.805.827.66 1.616 1.362 2.37 2.099z"
      fill="#E79335"
    />
    <path
      d="M36.081 44.58c3.296 3.047 6.009 4.616 9.763 5.236.106-.155.204-.319.311-.474a27.119 27.119 0 016.226-6.36c-1.913-5.275-3.879-10.265-10.854-15.497-5.446-4.085-13.845-4.486-14.089.858-.175 3.848 3.713 11.678 8.643 16.237"
      fill="#FBC732"
    />
    <path
      d="M47.07 48.16c.487-.625.993-1.22 1.52-1.788-5.65-8.632-12.907-16.785-17.35-17.066 1.867 8.512 8.615 15.195 15.83 18.854"
      fill="#E79335"
    />
    <path
      d="M65.492 37.575c-1.233-4.59-2.15-9.252-3.763-13.876-.594-1.698-1.37-4.473-2.6-7.503-1.696 1.34-3.91 1.534-5.885 1.18 1.737 7.129 4.657 14.248 6.766 21.608 1.74-.607 3.577-1.068 5.482-1.409"
      fill="#FBC732"
    />
    <path
      d="M57.35 3.778c-3.426-1.164-7.559-.237-9.516 2.706-1.957 2.943-1.18 7.524 1.847 9.537 2.641 1.754 8.759 2.934 11.195-2.034 2.22-4.534-.173-9.076-3.527-10.21"
      fill="#CD651D"
    />
    <path
      d="M90.973 39.898c1.474-4.706 3.374-10.967 4.352-15.565.362-1.698 1.4-4.982 2.155-7.404-2.073.1-4-.461-5.482-1.612-2.404 7.719-3.904 14.989-6.093 22.97a29.66 29.66 0 015.068 1.611z"
      fill="#FBC732"
    />
    <path
      d="M103.393 5.655c-2.259-2.15-6.439-3.964-10.576-1.4-4.137 2.564-4.098 6.369-2.68 8.916 1.698 3.047 5.266 4.352 9.015 3.55 3.749-.8 5.49-2.873 5.861-6.136.203-1.771-.31-3.676-1.62-4.93z"
      fill="#CD651D"
    />
    <path
      d="M53.134 86.322c-1.074-2.328-3.507-3.987-6.567-3.918-2.014.043-3.817 1.259-5.187 2.668-1.135 1.168-1.562 2.262-1.31 3.835.194 1.22 1.39 3.866 5.338 4.478 2.27.353 4.85.392 6.572-1.06 1.553-1.31 2.229-3.676 1.154-6.003zM107.767 82.034c-.573-.323-1.254-.483-1.935-.59-2.06-.337-4.426-.212-6.167 1.06-1.233.896-2.116 1.784-2.646 3.499-.526 1.715.728 4.081 1.75 4.939 1.017.857 3.744 2.09 7.089.702 2.025-.84 4.585-3.426 4.529-6.046-.035-1.573-1.879-3.142-2.62-3.564"
      fill="#F79162"
    />
    <path
      d="M47.982 75.117c.55 3.662 2.644 8.411 6.897 8.838 5.126.513 7.647-5.029 8.742-9.136.254-.96-1.229-1.366-1.487-.41-.883 3.323-2.678 8.098-6.838 8.05-3.732-.042-5.385-4.791-5.83-7.752-.147-.978-1.63-.56-1.484.41M88.396 74.1c.965 4.08 3.52 8.214 7.998 8.804 4.965.65 7.085-5.31 7.641-9.106.142-.97-1.34-1.388-1.482-.41-.5 3.418-1.879 8.184-6.159 7.973-3.706-.18-5.796-4.628-6.511-7.67-.229-.966-1.711-.557-1.487.409z"
      fill="#1F1611"
    />
    <path
      d="M125.772 103.422c-.716-11.709-8.055-19.41-15.993-12.945-4.167 3.395-2.624 5.554-6.942 5.71-3.586.129-14.221-3.09-35.708-1.634-10.427.707-12.333 2.099-18.952 3.017-5.644.784-3.536-.634-7.06-3.65-2.071-1.772-6.668-3.767-9.523-2.892-6.75 2.069-8.099 12.821-7.447 19.199.705 6.903 3.177 15.828 7.56 21.448 7.855 10.067 20.676 14.501 40.58 14.656 17.712.138 34.161-1.219 46.443-14.35 7.214-7.714 7.74-17.087 7.042-28.559z"
      fill="#E79335"
    />
    <path
      d="M113.042 96.438c-1.483 1.328-.547 3.655.819 4.521 1.663 1.051 4.369 2.689 6.145 1.418 1.775-1.272-2.293-10.127-6.964-5.939zM34.622 96.25c-4.807-.724-5.82 6.675-4.293 7.847 1.529 1.168 5.77-2.671 6.432-3.568 1.523-2.06.427-3.896-2.139-4.28"
      fill="#6F2D17"
    />
    <path
      d="M66.746 128.279c3.633 9.283 17.962 10.248 20.539-.25.24-.965-1.246-1.375-1.483-.409-2.193 8.925-14.462 8.196-17.574.25-.357-.914-1.844-.517-1.482.409"
      fill="#1F1611"
    />
    <path fill="#fff" fillOpacity={0.01} d="M149 149h1v1h-1z" />
  </>
    </AnimalFace>
  );
}
